import { render, staticRenderFns } from "./EcodopplerArtiInferioriEdit.vue?vue&type=template&id=9d0067aa&scoped=true"
import script from "./EcodopplerArtiInferioriEdit.vue?vue&type=script&lang=js"
export * from "./EcodopplerArtiInferioriEdit.vue?vue&type=script&lang=js"
import style0 from "./EcodopplerArtiInferioriEdit.vue?vue&type=style&index=0&id=9d0067aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0067aa",
  null
  
)

export default component.exports